import { render, staticRenderFns } from "./Page-Map-Online.vue?vue&type=template&id=72f671f8&"
import script from "./Page-Map-Online.vue?vue&type=script&lang=js&"
export * from "./Page-Map-Online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports